export default __webpack_public_path__ + "6e1985f0d7420af24b38ae34e57023e6.svg";